import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './biz-shop-product.action';
import { BizProduct } from '../../models/biz-product.model';

export interface ErrorPayload {
  message: string;
  statusCode: number;
}

export interface ShopProductState {
  bizShopProducts: { currentPage: number, data: BizProduct[], nextPage: number, pageSize: number, prevPage: number, totalItems: number, totalPages: number };
  loading: boolean;
  error: ErrorPayload | null;
}

export const initialState: ShopProductState = {
  bizShopProducts: { currentPage: 0, data: [], nextPage: 0, pageSize: 0, prevPage: 0, totalItems: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export const bizShopProductReducer = createReducer(
  initialState,

  // When loading biz products
  on(ProductActions.loadBizShopProducts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // On successful product load
  on(ProductActions.loadBizShopProductsSuccess, (state, { bizShopProducts }) => ({
    ...state,
    bizShopProducts,
    loading: false,
  })),

  // On failed product load
  on(ProductActions.loadBizShopProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
